import { Footer as SourceFooter } from 'AdvoxComponent/Footer/Footer.component';
import CmsBlock from 'Component/CmsBlock';
import CmsBlockProvider from 'Component/CmsBlockProvider';
import ContentWrapper from 'Component/ContentWrapper';
import Delayed from 'Component/Delayed';
import {
    FOOTER_ADDRESS_BLOCK_ID,
    FOOTER_SOCIAL_BLOCK_ID,
    NEWSLETTER_COLUMN,
    PaymentOptions,
    ShippingOptions,
} from 'Component/Footer/Footer.config';
import Icons from 'Component/Icons';
import Link from 'Component/Link';
import media from 'Util/Media';
import { LOGO_MEDIA } from 'Util/Media/Media';

import SuperMarka21 from '../../assets/images/Super_Marka_2021.png';
import SuperMarka22 from '../../assets/images/Super_Marka_2022.png';
import SuperMarka23 from '../../assets/images/Super_Marka_2023.png';

import './Footer.style.override.scss';

/** @namespace Pwa/Component/Footer/Component */
export class Footer extends SourceFooter {
    shouldComponentUpdate(nextProps) {
        const {
            device: { isMobile, isTablet },
            isVisibleOnMobile,
            copyright,
            newsletterActive,
            isCheckout,
        } = this.props;

        const {
            device: { isMobile: nextIsMobile, isTablet: nextIsTablet },
            isVisibleOnMobile: nextIsVisibleOnMobile,
            copyright: nextCopyright,
            newsletterActive: nextNewsletterActive,
            isCheckout: nextIsCheckout,
        } = nextProps;

        return (
            isMobile !== nextIsMobile ||
            isTablet !== nextIsTablet ||
            isVisibleOnMobile !== nextIsVisibleOnMobile ||
            copyright !== nextCopyright ||
            newsletterActive !== nextNewsletterActive ||
            isCheckout !== nextIsCheckout
        );
    }

    renderSocial() {
        return <CmsBlock identifier={FOOTER_SOCIAL_BLOCK_ID} blockType="social" />;
    }

    renderAddress() {
        return <CmsBlock identifier={FOOTER_ADDRESS_BLOCK_ID} blockType="address" />;
    }

    renderAwards() {
        return (
            <div block="Footer" elem="SuperBrand">
                <span block="Footer" elem="SuperMarka">
                    <img src={SuperMarka21} alt="SuperMarka" width="80px" height="80px" />
                </span>
                <span block="Footer" elem="SuperMarka">
                    <img src={SuperMarka22} alt="SuperMarka" width="80px" height="80px" />
                </span>
                <span block="Footer" elem="SuperMarka">
                    <img src={SuperMarka23} alt="SuperMarka" width="80px" height="80px" />
                </span>
            </div>
        );
    }

    renderLogo() {
        const { header_logo_src, logo_alt } = this.props;
        const logoSrc = header_logo_src ? media(header_logo_src, LOGO_MEDIA) : null;
        return (
            <Link
                to="/"
                aria-label="Go to homepage by clicking on ScandiPWA logo"
                block="Footer"
                elem="LogoWrapper"
                key="logo"
            >
                <img src={logoSrc} alt={logo_alt} />
            </Link>
        );
    }

    renderContact() {
        return (
            <div block="Footer" elem="ContactWrapper">
                <div block="Footer" elem="Contact">
                    <span block="Footer" elem="Logo">
                        {this.renderLogo()}
                    </span>

                    {this.renderAddress()}
                </div>
                {this.renderAwards()}
                {this.renderSocial()}
            </div>
        );
    }

    renderShippingMethods() {
        return (
            <div block="Footer" elem="ShippingMethos">
                <span> {__('Fast delivery:')}</span>
                {ShippingOptions.map((i) => (
                    <img key={i.label} src={i.icon} alt={i.label} height="32px" />
                ))}
            </div>
        );
    }

    renderCmsBlockWrapper() {
        const { footer_content: { footer_cms } = {} } = window.contentConfiguration;
        const {
            device: { isMobile, isTablet },
        } = this.props;

        return (
            <div block="Footer" elem="Content">
                <div block="Footer" elem="Columns" mix={{ block: 'ContentWrapper' }}>
                    {this.renderColumn({
                        ...NEWSLETTER_COLUMN,
                        mods: { isNewsletter: true },
                    })}
                    {(isMobile || isTablet) && this.renderContact()}
                    <CmsBlock identifier={footer_cms || 'footer_links'} blockType="footerLinks" />
                </div>
            </div>
        );
    }

    renderPaymentMethods() {
        return (
            <div block="Footer" elem="PaymentMethods">
                <span> {__('Secure payment:')}</span>
                {PaymentOptions.map((i) => (
                    <img key={i.label} src={i.icon} alt={i.label} height="32px" />
                ))}
            </div>
        );
    }

    renderMethodsOptions() {
        return (
            <ContentWrapper label="">
                <div block="Footer" elem="MethodsOptions">
                    {this.renderShippingMethods()}
                    {this.renderPaymentMethods()}
                </div>
            </ContentWrapper>
        );
    }

    renderContent() {
        const {
            device: { isMobile, isTablet },
        } = this.props;

        return (
            <div block="Footer" elem="Container">
                {this.renderCmsBlockWrapper()}
                {!isMobile && !isTablet && <ContentWrapper label="">{this.renderContact()}</ContentWrapper>}
                {this.renderMethodsOptions()}
            </div>
        );
    }

    renderCheckoutContent() {
        const {
            email,
            phone,
            device: { isMobile },
        } = this.props;

        return (
            <footer block="Footer" aria-label="Footer">
                <div block="Footer" elem="Container" mods={{ isCheckout: true }}>
                    <ContentWrapper label="">
                        <div block="Footer" elem="ActionItems">
                            <div block="Footer" elem="ActionItem" mods={{ isPhone: true }}>
                                <Icons name="phone" fill="#000" />
                                <a href={`tel:${phone}`}>{phone}</a>
                            </div>
                            <div block="Footer" elem="ActionItem">
                                <Icons name="envelop" />
                                <a href={`mailto:${email}`}>{email}</a>
                            </div>
                        </div>
                        {isMobile ? this.renderLogo() : null}
                    </ContentWrapper>
                </div>
            </footer>
        );
    }

    renderColumn = (column, i) => {
        const { title, subtitle, columnActiveKey, items, isItemsHorizontal, mods = {} } = column;
        const contentMods = isItemsHorizontal ? { direction: 'horizontal' } : {};
        const { [columnActiveKey]: isColumnActive } = this.props;

        if (columnActiveKey && !isColumnActive === true) {
            return null;
        }

        return (
            <div block="Footer" elem="Column" mods={mods} key={i}>
                <div block="Footer" elem="ColumnTitle">
                    {title}
                </div>
                <div block="Footer" elem="ColumnSubtitle">
                    {subtitle}
                </div>
                <div block="Footer" elem="ColumnContent" mods={contentMods}>
                    {items.map(this.renderColumnItem.bind(this))}
                </div>
            </div>
        );
    };

    render() {
        const { isCheckout } = this.props;

        return !isCheckout ? (
            <Delayed waitBeforeShow={400}>
                <CmsBlockProvider
                    identifiers={[
                        'newsletter_subscription_header',
                        'newsletter_subscription_header_text',
                        'newsletter_footer_label',
                        'footer_links',
                        'footer_address',
                        'footer_social',
                    ]}
                >
                    <footer block="Footer" aria-label="Footer">
                        {this.renderContent()}
                        {this.renderCopyrightContent()}
                    </footer>
                </CmsBlockProvider>
            </Delayed>
        ) : (
            this.renderCheckoutContent()
        );
    }
}

export default Footer;
